import { entityAPI, logAPI } from "api/GenericAPI";
import { Course , CourseLog } from "api/Interactions/InteractionsInterfaces";


// ================== API Factory ==================
export const coursesAPI = entityAPI<Course>("interactions", "courses");
export const courseLogAPI = logAPI<CourseLog>("interactions", "courses");

